import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import MultiSelect, { MultiSelectOption } from '../../../core/modules/common/components/MultiSelect';
import ColumnFilter from './ColumnFilter';
import { sortRowValues } from '../helpers/sortValues';

const initialCurrent = {
  valid: false,
};

class BooleanFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiSelectOptions: this.getOrderedUniqueValues(props),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data)) {
      this.setState({
        multiSelectOptions: this.getOrderedUniqueValues(nextProps),
      });
    }
  }

  getOrderedUniqueValues = props => _(props.data)
    .map((row) => {
      const value = props.column.accessor(row);
      if (value) {
        return new MultiSelectOption(true, 'Y');
      }
      return new MultiSelectOption(false, '(Blank)');
    })
    .uniqBy('value')
    .value()
    .sort(sortRowValues);

  isValid = multiSelectValues => (multiSelectValues && multiSelectValues.length > 0);

  render() {
    return (
      <ColumnFilter
        {...this.props}
        render={(current = initialCurrent, setCurrent) => (
          <div>
            <div className="advanced-filter__fields">
              <MultiSelect
                value={current.multiSelectValues}
                onChange={value => setCurrent({
                  ...current,
                  multiSelectValues: value,
                  valid: this.isValid(value),
                })}
                options={this.state.multiSelectOptions}
              />
            </div>
          </div>
        )}
      />
    );
  }
}

BooleanFilter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

export default BooleanFilter;
